import { StringHelper } from "@bryntum/schedulerpro";
import { GRANTS } from "@/other/constants/PrivilegeTypes";
import { canAddNewUser } from "@/other/utils/utils.jsx";
import {
  ENTITY_FINDER_ROW_HEIGHT,
  ENTITY_FINDER_ROW_HEIGHT_NO_SUBTITLE,
} from "@/modern/components/entity-finder/constants/layout";
import type { EntityFinderContext, EntityFinderItem } from "@/modern/components/entity-finder/types";

export function openEntityEditor(
  ctx: EntityFinderContext,
  editorKey: string,
  record: unknown,
  payload: Record<string, unknown>,
  options?: Record<string, unknown>
) {
  const openEditor = ctx.editorHandler.openEditor as (...args: unknown[]) => void;
  if (options) {
    openEditor(editorKey, record, payload, options);
  } else {
    openEditor(editorKey, record, payload);
  }
}

export function canCreate(ctx: EntityFinderContext): boolean {
  return Boolean(ctx.project && ctx.user?.can(GRANTS.grant_four));
}

export function canCreateUser(ctx: EntityFinderContext): boolean {
  return Boolean(ctx.project && ctx.user && canAddNewUser(ctx.user));
}

export function canCreateBudget(ctx: EntityFinderContext): boolean {
  const user = ctx.user;
  if (!ctx.project || !user) return false;
  if (user.isSandboxBoard && user.isDemoUser) return false;
  return user.can(GRANTS.grant_two);
}

export function navigateToAnonymousView(
  ctx: EntityFinderContext,
  viewType: string,
  viewName: string,
  pathSuffix: string
) {
  const boardSlug = ctx.selectedBoard?.record?.slug;
  if (!boardSlug || !ctx.viewManager) return;

  const vm = ctx.viewManager as EntityFinderContext["viewManager"] & {
    selectViewAnonymousView: (id: string, viewName: string, viewType: string) => void;
  };

  const id = StringHelper.generateUUID();
  ctx.history.push(`/${boardSlug}/${pathSuffix}`, { viewId: id, viewType });
  vm.selectViewAnonymousView(id, viewName, viewType);
  if (ctx.entityManager.isOpen) {
    ctx.entityManager.closeEntityManager();
  }
}

export function estimateDefaultRowHeight(item: EntityFinderItem): number {
  return item.subtitle ? ENTITY_FINDER_ROW_HEIGHT : ENTITY_FINDER_ROW_HEIGHT_NO_SUBTITLE;
}
